// extracted by mini-css-extract-plugin
export default {"ErrorsContainer":"ErrorsContainer_ErrorsContainer__25U7g"};